import React from "react";
import {bindActionCreators} from "redux";
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import { AgGridReact as Grid } from "ag-grid-react"
import styled from "styled-components"
import { DangerButton, DateRenderer, WarningButton } from "../../../components"
import * as actions from "../irr.actions"
import * as selectors from '../irr.selectors';
import * as applicationActions from "../../../application.actions"
import * as applicationSelectors from "../../../application.selectors";
import * as periodSelectors from "../../periods/period.selectors";
import {ConfirmationBox} from "./confirmationBox";

const Container = styled.div`
  width: 100%;
  height: 600px;
`

export class IrrNurseGrid extends React.PureComponent {
    api = null;
    columnApi = null;
    state = {
        show: false,
        data: [],
        columns: {
            irrDate: {
                headerName: "IRR Date",
                colId: 'irrDate',
                field: "irrDate",
                cellRenderer: "dateRenderer",
                width: 85
            },
            irrType: {
                headerName: "IRR Type",
                colId: 'irrType',
                field: "irrType",
                width: 85
            },
            nurse: {
                headerName: 'Reviewed Nurse',
                colId: 'nurse',
                field: "nurse",
                width: 130
            },
            reviewer: {
                headerName: "IRR Reviewer",
                colId: 'irrReviewer',
                field: "irrReviewer",
                width: 120
            },
            startDate: {
                headerName: "Start Date",
                field: "period.periodStart",
                colId: 'startDate',
                cellRenderer: "dateRenderer",
                width: 90
            },
            endDate: {
                headerName: "End Date",
                field: "period.periodEnd",
                colId: 'endDate',
                cellRenderer: "dateRenderer",
                width: 90
            },
            quarter: {
                headerName: "Quarter",
                colId: 'quarter',
                field: "quarter",
                width: 70
            },
            year: {
                headerName: "Year",
                colId: 'year',
                field: "year",
                width: 70
            },
            actions: {
                headerName: "Actions",
                //roles: this.props.roles,
                type: "actionsColumn",
                cellRenderer: "actionsRenderer",
                width: 160
            }
        }
    };

    componentWillReceiveProps(nextProps) {
        if (this.api && this.props.data !== nextProps.data) {
            this.api.refreshCells();
        }
    }

    onGridReady = ({ api, columnApi }) => {
        this.api = api;
        this.columnApi = columnApi;
        
        api.setFilterModel(this.props.gridFilterModel);
        api.paginationGoToPage(this.props.currentPage);
        setTimeout(() => api.sizeColumnsToFit(), 300);
    }

    deleteIrrClick = (row) => {
        // replace with stylized confirmation
        this.setState({
            ...this.state,
            showConfirmModal: true,
            doIRRDelete: () => {
                const { rowDelete } = this.props;
                rowDelete(row);
            }
        });
    }

    deleteCancel = () => {
        this.setState({
            ...this.state,
            showConfirmModal: false
        });
    }

    onFilterChanged = ({ api }) =>
        actions.gridFilterChanged(api.getFilterModel());
    onSortChanged = ({ api }) =>
        actions.gridSortChanged(api.getSortModel());
    onPaginationChanged = ({ api }) =>
        actions.gridPaginationChanged(api.paginationGetCurrentPage());

    gridActions = (history) => ({ data }) => {
        return (
            <span>
                <WarningButton onClick={() => history.push(`/irr/${data.id}`)}>
                    View
                </WarningButton>
                <DangerButton onClick={() => this.deleteIrrClick(data)}>Delete</DangerButton>
            </span>
        )
    }

    render() {
        const { showConfirmModal, doIRRDelete} = this.state;
        const { nurses, periods } = this.props;
        const message = 'If there were any IRR reviews completed, these will be permanently deleted. Are you sure you want to delete the sample?';
        const data = nurses.map(n => {
            const per = periods.filter(p => p.id == n.periodId)[0];
            if(!per) return;
            const date = new Date(this.unUTCDate(per.periodEnd));
            return {
                ...n,
                period: per,
                quarter: `Q${(date.getMonth() + 1) / 3}`,
                year: date.getFullYear()
            };
        });

        return (
            <Container className="ag-fresh">
                <Grid
                    onPaginationChanged={this.onPaginationChanged}
                    onFilterChanged={this.onFilterChanged}
                    onSortChanged={this.onSortChanged}
                    rowData={data}
                    onGridReady={this.onGridReady}
                    paginationPageSize={15}
                    pagination={true}
                    enableFilter={true}
                    enableSorting={true}
                    suppressMovableColumns={true}
                    headerHeight={35}
                    rowHeight={35}
                    enableColResize={true}
                    columnDefs={Object.values(this.state.columns)}
                    defaultColDef={{ filterParams: { newRowsAction: 'keep' } }}
                    columnTypes={{
                        actionsColumn: { suppressMenu: true, suppressSorting: true }
                    }}
                    frameworkComponents={{
                        actionsRenderer: this.gridActions(this.props.history),
                        dateRenderer: DateRenderer
                    }}
                />
                <ConfirmationBox title="Delete Sample" message={message} showModal={showConfirmModal} accept={doIRRDelete} cancel={this.deleteCancel}></ConfirmationBox>
            </Container>
        )
    }
 
    unUTCDate = (dateStr) => {
        return dateStr.replace("Z", "");
      }
}

export default withRouter(
    connect(
        (state) => ({
            roles: applicationSelectors.roles(state),
            fetching: state.data.fetching,
            irrs: selectors.irrs(state),
            periods: periodSelectors.periods(state)
        }),
        (dispatch) => ({
            actions: bindActionCreators(
                {
                    ...applicationActions,
                    ...actions
                },
                dispatch
            ),
        })
    )(IrrNurseGrid));



// WEBPACK FOOTER //
// ./src/modules/irr/components/irrNurseGrid.js